import {type ExpoScrollForwarderViewProps} from './ExpoScrollForwarder.types'

export function ExpoScrollForwarderView({
  children,
}: React.PropsWithChildren<ExpoScrollForwarderViewProps>) {
  return children
}
